import { render } from "./PresalesHandoverForm.vue?vue&type=template&id=e51dc548&scoped=true"
import script from "./PresalesHandoverForm.vue?vue&type=script&lang=js"
export * from "./PresalesHandoverForm.vue?vue&type=script&lang=js"

import "./PresalesHandoverForm.vue?vue&type=style&index=0&id=e51dc548&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e51dc548"]])

export default __exports__